import { DBDef_PertinentCategory } from '@app/advisor-ui-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_PertinentCategory } from '../../_entity.js';
import { ConfigDialog_PertinentCategory_Order } from '../../ui/config-dialogs/ConfigDialog_PertinentCategory_Order/ConfigDialog_PertinentCategory_Order.js';
import { Manager_PertinentCategory } from '../../ui/_managers/Manager_PertinentCategory/Manager_PertinentCategory.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_PertinentCategory,
    dbDef: DBDef_PertinentCategory,
    tag: ['PC', 'Pertinent Category'],
    modulesToAwait: [ModuleFE_PertinentCategory],
    ManagerComponent: Manager_PertinentCategory,
    extraMenuSections: () => [{
            label: 'Configuration',
            actions: [{
                    label: 'Category Order',
                    action: () => ConfigDialog_PertinentCategory_Order.show(),
                }],
        }],
});
export const WorkHubItem_PertinentCategory = WorkHubItem;
export const UtilObject_PertinentCategory = UtilObject;
export const SearchItem_PertinentCategory = SearchItem;
//# sourceMappingURL=pertinent-category.js.map